var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"Select User","visible":_vm.isOpen,"width":"30%"},on:{"close":_vm.close}},[_c('div',[_c('UserSelectorCpt',{attrs:{"on-selected":_vm.onUserSelected,"find-method":_vm.findMethod}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }